import * as React from 'react';

import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { UserContext } from '../UserContext';
import { Avatar, Button, Card, CardContent, Container, Divider, Grid, List, ListItem, ListItemAvatar, ListItemIcon, ListItemText, TextField, Toolbar, Typography } from '@mui/material';
import useRemote from '../state/useRemote';
import { useNavigate, useParams } from 'react-router-dom';
import MailIcon from '@mui/icons-material/Mail';
import Message from '../components/Message';

const UserDetailsPage = () => {

	const [users, setUsers] = React.useState([])
	const { user } = React.useContext(UserContext);

	const [official, setOfficial] = React.useState(null);

	const { uuid } = useParams();
	const remote = useRemote();
	const navigate = useNavigate();

	React.useEffect(() => {
		remote.get(`official/${uuid}`).then(setOfficial).catch(() => navigate("/users"));
	}, [uuid]);

	const inputRef = React.useRef(null);

	const send = () => {
		console.log("Sending message", inputRef.current.value);
		if (!inputRef.current.value) {
			return;
		}
		remote.post(`official/${uuid}/message`, { message: inputRef.current.value })
			.then(setOfficial)
			.catch((e) => console.error("Error sending message", e));
		inputRef.current.value = "";
	};

	const drawerWidth = 240;

	console.log("Official is ", official);

	if (!official) {
		return <Box sx={{ p: 3 }}>Loading...</Box>;
	}

	return (
		<>
		<Box
				component="main"
				sx={{ flexGrow: 1, p: 3, width: { sm: `calc(100% - ${drawerWidth}px)` } }}
			>
				<div style={{ padding: '20px', paddingTop: '80px'}}>
			
				<Grid container spacing={2}>
				<Grid size={{ xs: 6, md: 8 }}>
					<Card style={{ width: '400px' }}>
						<CardContent>
							<Avatar alt={official.name} src="/path/to/profile/picture.jpg" />
							<Typography variant="h5" component="h2">
								{official.name}
							</Typography>
							<Typography variant="subtitle1" color="textSecondary">
								{official.role}
							</Typography>
						</CardContent>
					</Card>

					{/* Contact Details */}
					<Card style={{ marginTop: '20px' }}>
						<CardContent>
							<Typography variant="h6" component="h3">
								Contact Details
							</Typography>
							<List>
								<ListItem>
									<ListItemIcon>
										<MailIcon />
									</ListItemIcon>
									<ListItemText primary="Email" secondary={official.email} />
								</ListItem>
							</List>
						</CardContent>
					</Card>

					{/* Buttons */}
					<Button variant="contained" color="primary" style={{ marginTop: '20px' }}>
						Edit Profile
					</Button>
					</Grid>
				</Grid>
			</div>
			<Card><CardContent>
		<List sx={{ width: '100%', bgcolor: 'background.paper', paddingTop: '80px' }}>
			{official.messages.map((message, index) => (<Message key={message.id} message={message} type="received" />))}
			<ListItem>
			<Box sx={{ display: 'flex', alignItems: 'center', padding: '20px', width: '100%' }}>
			<TextField
				inputRef={inputRef}
				fullWidth
				multiline
				variant="outlined"
				minRows={3}
				placeholder="Type your message here..."
				sx={{ marginRight: '10px', flex: 1 }}
			/>
			<Button variant="contained" color="primary" onClick={send}>
				Send
			</Button>
		</Box>

			</ListItem>
    </List>
	</CardContent></Card>
			</Box>
		</>
	)

}

export default UserDetailsPage;